export default class Debounce {
  private timeout: any;
  constructor(private debounceMS: number) {}

  public setDebounceMS(ms: number) {
    this.debounceMS = ms;
  }

  public async call(func: () => void) {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(func, this.debounceMS);
  }

  public clear() {
    clearTimeout(this.timeout);
  }
}
